import Vue from 'vue';
import Image from '.';
const defaultImage = localStorage.getItem('uicore:defaultImage') || 'https://vfiles.gtimg.cn/wuji_dashboard/xy/starter/23802034.jpg';

/** @type {UICore.ComponentMeta} */
const ImageComponentMeta = {
  id: 'w-image',
  name: '图片',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-image_1636364242747.png',
  category: '展示',
  component: Image,
  bindings: [{
    id: '图片地址',
    prop: 'src',
    main: true,
    checkData: schema => schema.type === 'string'
  }],
  events: [{
    id: 'click',
    name: '点击图片'
  }, {
    id: 'mouseenter',
    name: '鼠标进入'
  }, {
    id: 'mouseleave',
    name: '鼠标离开'
  }],
  presets: [
  // 这里配置的是从组件库拖出来时候的预设
  {
    name: '图片',
    layout: {
      props: {
        src: defaultImage
      },
      style: {
        width: '300px'
      }
    }
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'src',
      type: 'string',
      title: '图片地址',
      default: defaultImage
    }, {
      id: 'fallbackSrc',
      type: 'string',
      title: '兜底图图片地址',
      default: ''
    }, {
      id: 'fillMode',
      type: 'string',
      title: '填充模式',
      enum: [{
        value: 'fill',
        label: '拉伸'
      }, {
        value: 'contain',
        label: '等比(显示全部)'
      }, {
        value: 'cover',
        label: '等比(填满)'
      }]
    }, {
      id: 'useFallbackIfSrcIsEmpty',
      type: 'boolean',
      default: true,
      title: '图片地址为空时，展示兜底图而非白块'
    }, {
      id: 'css',
      type: 'string',
      title: '自定义CSS',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }]
  },
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type === 'string') {
      const isImage = dataPath.match(/\.(jpeg|jpg|gif|png)$/) !== null;
      return [{
        type: 'display',
        name: '图片',
        layouts: [{
          preview: isImage ? dataPath : 'https://vfiles.gtimg.cn/wuji_dashboard/xy/lyprodtest/sNcYNIlP.png',
          title: '拉伸',
          layout: {
            type: 'w-image',
            bindings: {
              图片地址: dataPath
            },
            style: {
              width: '300px',
              height: '300px'
            },
            props: {
              fillMode: 'fill'
            }
          }
        }, {
          preview: isImage ? dataPath : 'https://vfiles.gtimg.cn/wuji_dashboard/xy/lyprodtest/iZjFr4Qh.png',
          title: '等比(显示全部)',
          layout: {
            type: 'w-image',
            bindings: {
              图片地址: dataPath
            },
            style: {
              width: '300px',
              height: '300px'
            },
            props: {
              fillMode: 'contain'
            }
          }
        }, {
          preview: isImage ? dataPath : 'https://vfiles.gtimg.cn/wuji_dashboard/xy/lyprodtest/tsgWnmyq.png',
          title: '等比(填满)',
          layout: {
            type: 'w-image',
            bindings: {
              图片地址: dataPath
            },
            style: {
              width: '300px',
              height: '300px'
            },
            props: {
              fillMode: 'cover'
            }
          }
        }]
      }];
    }
  },
  getActions({
    instance,
    modifyComp
  }) {
    return [{
      title: '重置宽高',
      icon: 'fa fa-magic',
      async execute() {
        await modifyComp(c => {
          /** @type {HTMLImageElement} */
          const img = instance.$el;
          const width = img.offsetWidth;
          const height = (img.naturalHeight * width / img.naturalWidth).toFixed(2);
          Vue.set(c, 'style', {
            ...c.style,
            width: `${width}px`,
            height: `${height}px`
          });
        });
      }
    }];
  },
  designerQuickEdit: [{
    trigger: {
      dblclick: true,
      selected: {
        onlyInserting: true
      }
    },
    content: ['prop:src', 'prop:fillMode']
  }]
};
export default ImageComponentMeta;